import React, { Component } from "react";
import { MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody, MDBModal, toast, ToastContainer, MDBSelect, MDBSelectInput, MDBSelectOptions, MDBSpinner } from "mdbreact";
import Navigation from "../../../components/NetworkMgmt/Navigation/Navigation";
import QuickLinks from "../../../components/NetworkMgmt/QuickLinks/QuickLinksWithWizard";
import SummaryCardVenues from "../../../components/NetworkMgmt/Dashboard/SummaryCardVenues";
import SummaryCardSubscribers from "../../../components/NetworkMgmt/Dashboard/SummaryCardSubscribers";
import ViewVenuesTable from "../../../components/NetworkMgmt/Venues/Datatables/VenuesTableMUI";
import ViewVenuesTableSmall from "../../../components/NetworkMgmt/Venues/Datatables/VenuesTableSmall";
import ModifyVenue from "../../../components/NetworkMgmt/Forms/ModifyVenue/ModifyVenue";
import axios from "../../../axios";
import _ from "lodash";
import { withTranslation } from "react-i18next";
import LogoFooter from "../../../components/Logo/logoFooter";
const initialState = { isLoading: false, results: [], value: "" };
let source1 = [];
class Dashboard extends Component {
    state = {
        selectedName: sessionStorage.getItem("venueName") !== undefined ? sessionStorage.getItem("venueName") : null,
        initialState,
        venueData: [],
        activeData: undefined,
        refreshed: false,
        loading: false,
        venueType: "",
        buildings: [],
        darkmode: JSON.parse(localStorage.getItem("darkMode")),
        showError: false,
        errorMessage: undefined,
        venueAdminList: {},
        hasUpdated: false,
        loadingVenueDetails: false,
        // Enhanced loading states for componentDidMount functions
        isInitialLoading: true,
        loadingStates: {
            displayOptions: true,
            displayOptionsList: true,
            venues: true,
            venueDetails: true,
            userInfo: true,
            operatorInfo: true,
        },
        loadingProgress: 0,
        venueRefreshTrigger: 0, // Increment this to force venue data refresh
    };
    componentDidMount() {
        this.initializeDashboard();
        // document.title = "Wi-Fi Management Console";
    }
    initializeDashboard = async () => {
        const loadingFunctions = [
            { func: this.getDisplayOptions, name: "displayOptions" },
            { func: this.getDisplayOptionsList, name: "displayOptionsList" },
            { func: this.getVenues, name: "venues" },
            { func: this.getUserInfo, name: "userInfo" },
            { func: this.getOperatorInfo, name: "operatorInfo" },
        ];
        const totalFunctions = loadingFunctions.length;
        let completedFunctions = 0;
        for (const { func, name } of loadingFunctions) {
            try {
                await func();
                completedFunctions++;
                // eslint-disable-next-line
                this.setState((prevState) => ({
                    loadingStates: {
                        ...prevState.loadingStates,
                        [name]: false,
                    },
                    loadingProgress: Math.round((completedFunctions / totalFunctions) * 100),
                }));
            } catch (error) {
                console.error(`Error loading ${name}:`, error);
                // eslint-disable-next-line
                this.setState((prevState) => ({
                    loadingStates: {
                        ...prevState.loadingStates,
                        [name]: false,
                    },
                    loadingProgress: Math.round((completedFunctions / totalFunctions) * 100),
                }));
            }
        }
        // Mark initial loading as complete
        this.setState({ isInitialLoading: false });
    };
    searchData = () => {
        return this.state.searchData;
    };
    updateName = async (value, index) => {
        // Full venue management context - loads all supporting data
        console.log('🚨 updateName (FULL) called for venue management context with:', { value, index });
        sessionStorage.setItem("venueName", value);
        sessionStorage.setItem("venueID", index);
        this.setState({ 
            selectedName: value,
            selectedID: index,
            venueID: index,
            venueRefreshTrigger: this.state.venueRefreshTrigger + 1 // Increment to trigger refresh
        });
        await this.getVenueDetails(index);
        this.getVenues(); // Load supporting data for venue management pages
    };
    updateNameForModal = async (value, index) => {
        // Dashboard modal context - only loads venue details
        console.log('🚨 updateNameForModal (MODAL) called for Dashboard dropdown');
        sessionStorage.setItem("venueName", value);
        sessionStorage.setItem("venueID", index);
        this.setState({ selectedName: value });
        this.setState({ selectedID: index });
        this.setState({ venueID: index });
        await this.getVenueDetails(index);
        // No getVenues() call - modal only needs venue details
    };
    updateVenueList = (venueListIn) => {
        let venueName1 = [];
        let venueListNameTemp = [];
        for (let count = 0; count <= Object.keys(venueListIn).length - 1; count++) {
            let venueList_a = Object.keys(venueListIn);
            venueName1[venueList_a[count]] = venueListIn[venueList_a[count]]["VenueName"];
            venueListNameTemp = [...venueListNameTemp, venueName1];
        }
        this.setState({
            venueList: venueListIn,
            venueListName: venueListNameTemp,
        });
    };
    getDisplayOptions = () => {
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
        };
        return axios
            .post("/networkoperatorconsole/equipment/listOperatorDetails", body, {
                headers: {},
            })
            .then((response) => {
                const root = document.documentElement;
                // console.log("theme changed")
                let theme;
                if (localStorage.getItem("darkMode") === "false" || localStorage.getItem("darkMode") === null) {
                    theme = "ThemeLight";
                } else {
                    theme = "ThemeDark";
                }
                // console.log(theme)
                this.setState({
                    s3Directory: response.data.DisplayConfiguration["Behavior"]["S3Directory"],
                    logo: response.data.DisplayConfiguration[theme]["LogoFileNameDesktopMobileAfterLogin"],
                });
                root?.style.setProperty("--background-color", response.data.DisplayConfiguration[theme]["BackgroundColorHex"]);
                root?.style.setProperty("--additional-color", response.data.DisplayConfiguration[theme]["BorderColorHex"]);
                root?.style.setProperty("--modal-background-color", response.data.DisplayConfiguration[theme]["ModalColorHex"]);
                root?.style.setProperty("--primary-text-color", response.data.DisplayConfiguration[theme]["PrimaryTextColorHex"]);
                root?.style.setProperty("--primary-color", response.data.DisplayConfiguration[theme]["PrimaryColorHex"]);
                root?.style.setProperty("--new-primary-color", response.data.DisplayConfiguration[theme]["PrimaryColorHex"]);
                root?.style.setProperty("--secondary-color", response.data.DisplayConfiguration[theme]["SecondaryColorHex"]);
                root?.style.setProperty("--border-color", "#BFBFBF");
                root?.style.setProperty("--primary-color-rgb", response.data.DisplayConfiguration[theme]["PrimaryColorHex"] + "4D");
                root?.style.setProperty("--button-color", response.data.DisplayConfiguration[theme]["PrimaryColorHex"]);
                root?.style.setProperty("--button-text-color", "#FFF");
                root?.style.setProperty("--summary-card-color", response.data.DisplayConfiguration[theme]["SecondaryColorHex"]);
                root?.style.setProperty("--navbar-text-color", response.data.DisplayConfiguration[theme]["PrimaryTextColorHex"]);
                root?.style.setProperty("--navbar-color", response.data.DisplayConfiguration[theme]["NavbarColorHex"]);
                root?.style.setProperty("--card-color", response.data.DisplayConfiguration[theme]["NavbarColorHex"]);
                root?.style.setProperty("--input-color", response.data.DisplayConfiguration[theme]["InputBoxColorHex"]);
                root?.style.setProperty("--input-focus-color", response.data.DisplayConfiguration[theme]["BannerColor2Hex"]);
                sessionStorage.setItem("cartEnabledGlobally", response.data.ShoppingCart.enableShoppingCart);
                this.setState({
                    // s3Directory:
                    //     response.data.DisplayConfiguration["Behavior"][
                    //         "S3Directory"
                    //     ],
                    // logo: response.data.DisplayConfiguration[theme][
                    //     "LogoFileNameDesktopMobileAfterLogin"
                    // ],
                    displayOptionID: response.data.DisplayOptionID,
                    operatorName: response.data.OperatorName,
                    cancelInputType: response.data["DisplayConfiguration"]["Behavior"]["CancellationMethod"],
                    showUpdate: response.data["DisplayConfiguration"]["ShoppingCart"]["AllowSelfPaymentMethodUpdate"],
                    showSupport: response.data.DisplayConfiguration["Support"]["ShowSupportLinks"],
                    externalSupport: response.data.DisplayConfiguration["Support"]["ExternallyManagedSupport"],
                    externalSupportLink: response.data.DisplayConfiguration["Support"]["ExternalSupportSystemURL"],
                    showDevices: response.data.DisplayConfiguration["ShowEquipmentStatusToVenueAdministrator"],
                    // globalNetworkConfiguration: response.data["NetworkConfiguration"],
                    // globalMessagingConfiguration: response.data["Notifications"],
                    // globalRealPageConfiguration: response.data["PMS"],
                    // globalShoppingCartConfiguration: response.data["ShoppingCart"],
                    // allowOverlapping:
                    //   response.data["NetworkConfiguration"][
                    //     "allowOverlappingSubscriptionWiredUnit"
                    //   ],
                    // selectDefaultServicePlanResident:
                    //   response.data["ServicePlanConfiguration"][
                    //     "DefaultServicePlanID_GlobalWirelessPlusLocalWiredAccess"
                    //   ],
                    // selectDefaultServicePlanWireless:
                    //   response.data["ServicePlanConfiguration"][
                    //     "DefaultServicePlanID_LocalWirelessAccess"
                    //   ],
                    // globalKeyPoolList:
                    //   response.data["NetworkConfiguration"]["GlobalSSID"],
                    operatorID: response.data["OperatorID"],
                    currencyNames: response.data["ServicePlans"][0]["Currencies"],
                });
                sessionStorage.setItem("currencyNames", JSON.stringify(response.data["ServicePlans"][0]["Currencies"]));
                sessionStorage.setItem("cancelInputType", response.data.DisplayConfiguration["Behavior"]["CancellationMethod"]);
                sessionStorage.setItem("showUpdate", response.data.DisplayConfiguration["ShoppingCart"]["AllowSelfPaymentMethodUpdate"]);
                sessionStorage.setItem("showCustomPSK", response.data["NetworkConfiguration"]["CustomPSK"]);
                sessionStorage.setItem("loggedInNO", true);
                sessionStorage.setItem("logoURL", response.data.DisplayConfiguration[theme]["LogoFileNameDesktopMobileAfterLogin"]); 
                // Check if SMS is enabled by checking for SNS SMS phone number
                const smsEnabled = !!(response.data["Notifications"] && 
                                    response.data["Notifications"]["SNS"] && 
                                    response.data["Notifications"]["SNS"]["SMSConsolePhoneNumber"]);
                sessionStorage.setItem("SMSEnabled", smsEnabled);
            })
            .catch((error) => {});
    };
    getDisplayOptionsList = () => {
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
        };
        this.setState({
            loading_info: true,
            operatorInfo: undefined,
        });
        return axios
            .post("/operatorconsole/config/listDisplayOptions", body, {
                headers: {},
            })
            .then(
                (response) => {
                    let optionTemplateDisplayOptions = [];
                    this.setState({
                        allDisplayOptions: response.data.DisplayOptions,
                        allMetaOptions: response.data.metaOptions,
                    });
                    Object.keys(response.data.DisplayOptions).map((oneKey, i) => {
                        optionTemplateDisplayOptions.push({
                            value: response.data.DisplayOptions[oneKey]["DisplayOptionID"],
                            name: response.data.DisplayOptions[oneKey]["DisplayOptionName"],
                        });
                        return true;
                    });
                    this.setState({ loading_info: false });
                    this.setState({
                        optionTemplateDisplayOptions: optionTemplateDisplayOptions,
                        loading_info: false,
                    });
                },
                (error) => {
                    this.setState({ loading_info: false });
                }
            );
    };
    getVenues = async (selectedID) => {
        // console.log('🚨 getVenues called');
        let body = { 
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
        };
        this.setState({
            attributeForm: [],
            venueListForTable: undefined,
        });
        await axios
            .post("/networkoperatorconsole/venues/listVenues", body, {
                headers: {},
            })
            .then((response) => {
                let firstID;
                this.setState({
                    venueList: response.data,
                    venueListForTable: response.data.VenueList,
                });
                var formArrayVenues = [];
                let optionTemplateVenues = [];
                // Object.keys(response.data.VenueList).map((oneKey, i) => {
                // 	if (i === 0 && selectedID === undefined) {
                // 		firstID = oneKey;
                // 		selectedID = oneKey;
                // 	}
                // 	if (selectedID === oneKey) {
                // 		optionTemplateVenues.push(
                // 			<MDBSelectOption selected value={oneKey} key={i}>
                // 				{response.data.VenueList[oneKey]["VenueName"]}
                // 			</MDBSelectOption>
                // 		);
                // 	} else {
                // 		optionTemplateVenues.push(
                // 			<MDBSelectOption value={oneKey} key={i}>
                // 				{response.data.VenueList[oneKey]["VenueName"]}
                // 			</MDBSelectOption>
                // 		);
                // 	}
                // 	return true;
                // });
                optionTemplateVenues.push({
                    value: "",
                    name: "Select...",
                });
                Object.keys(response.data.VenueList).map((oneKey, i) => {
                    // if (i === 0 && selectedID === undefined) {
                    // 	firstID = oneKey;
                    // 	selectedID = oneKey;
                    //  sessionStorage.setItem("venueID", firstID);
                    // }
                    optionTemplateVenues.push({
                        value: oneKey,
                        name: response.data.VenueList[oneKey]["VenueName"],
                    });
                    return true;
                });
                this.setState({
                    optionTemplateVenues: optionTemplateVenues,
                    loading_prop_groups: false,
                });
                // Removed unnecessary getVenueDetails call - venue details are already loaded by updateName method
                formArrayVenues.push(
                    <MDBSelect id="selectVenueResidentModal" getValue={this.handleSelectChangeVenue} className="form-control">
                        <MDBSelectInput className="selectInput venueSelectedResidentModal" selected="Choose your venue" />
                        <MDBSelectOptions search>{optionTemplateVenues}</MDBSelectOptions>
                    </MDBSelect>
                );
                this.setState({
                    attributeForm: formArrayVenues,
                });
                // console.log('🚨 getVenues: About to call getPropertyManagementGroups()');
                this.getPropertyManagementGroups();
                if (this.state.venueAdminList.length !== 0) {
                    this.getAdmins();
                }
            })
            .catch((error) => {
                this.setState({ showError: true });
                // this.setState({ errorMessage: "The listVenues API timed out"})
                this.setState({ error: true });
            });
    };
    getVenuesList = async (selectedID) => {
        let body = { 
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
        };  
        this.setState({
            venueListForTable: undefined,
        });
        await axios
            .post("/networkoperatorconsole/venues/listVenues", body, {
                headers: {},
            })
            .then((response) => {
                this.setState({
                    venueList: response.data,
                    venueListForTable: response.data.VenueList,
                });
                // Removed getPropertyManagementGroups() call - it's already called in initializeDashboard
            })
            .catch((error) => {
                this.setState({ error: true });
            });
    };
    getVenueDetails = async (index) => {
        // console.log('🚨 Dashboard getVenueDetails called with index:', index);
        // console.log("%c getVenueDetails called with index:" + index, "background: #222; color: #bada55; font-size: 14px");
        // Always set loadingVenueDetails to true at the start
        this.setState(
            {
                loadingVenueDetails: true,
                unitData: undefined,
                expiringData: undefined,
                searchData: undefined,
                value: "",
                servicePlans: undefined,
                keyPoolList: undefined,
                venueAdminList: {},
                venueEquipList: undefined,
                venueLeasingAgentList: {},
                staffArrayAll: undefined,
                venueInfo: undefined,
                activeData: undefined,
                activeData1Day: undefined,
                activeData7Day: undefined,
                expiringData14Days: undefined,
                guestDataExpiring: undefined,
            },
            () => {
                console.log('Dashboard: loadingVenueDetails set to TRUE - Modal should be visible now');
            }
        );
        let cookieVenueName = sessionStorage.getItem("venueID");
        cookieVenueName === null ? (cookieVenueName = "") : (index = cookieVenueName);
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            VenueID: index,
            UserTimeZone: new Date().getTimezoneOffset(),
        };
        source1 = [];
        if (index !== undefined) {
            console.log('🚨 Dashboard getVenueDetails: About to call API with index:', index);
            await axios
                .post("/networkoperatorconsole/venues/listVenueDetails", body, {
                    headers: {},
                })
                .then((response) => {
                    console.log('✅ Dashboard getVenueDetails: API call successful, response received');
                    // var sortedKeys = _(response.data[index]["Keypools"])
                    //     .map(function (v, k) {
                    //         // insert the key into the object
                    //         return _.merge({}, v, { key: k });
                    //     })
                    //     .sortBy("DisplayOrder") // sort by name
                    //     .value();
                    this.setState({
                        leasingAgents: [],
                        venueAdmins: [],
                    });
                    // Filter subscriptions that started in the last 7 days
                    const sevenDaysAgo = new Date();
                    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
                    const recentSubscriptions = Object.keys(response.data[index]["Subscriptions"] || {})
                        .filter(subscriptionKey => {
                            const subscription = response.data[index]["Subscriptions"][subscriptionKey];
                            const startDate = new Date(subscription["StartDateTimeUTC.ISO8601"]);
                            return startDate >= sevenDaysAgo;
                        })
                        .reduce((obj, key) => {
                            obj[key] = response.data[index]["Subscriptions"][key];
                            return obj;
                        }, {});
                    // Filter subscriptions that started in the last 24 hours
                    const twentyFourHoursAgo = new Date();
                    twentyFourHoursAgo.setHours(twentyFourHoursAgo.getHours() - 24);
                    const last24HoursSubscriptions = Object.keys(response.data[index]["Subscriptions"] || {})
                        .filter(subscriptionKey => {
                            const subscription = response.data[index]["Subscriptions"][subscriptionKey];
                            const startDate = new Date(subscription["StartDateTimeUTC.ISO8601"]);
                            return startDate >= twentyFourHoursAgo;
                        })
                        .reduce((obj, key) => {
                            obj[key] = response.data[index]["Subscriptions"][key];
                            return obj;
                        }, {});
                    // Filter subscriptions that will start in the next 7 days
                    const now = new Date();
                    const sevenDaysFromNow = new Date();
                    sevenDaysFromNow.setDate(sevenDaysFromNow.getDate() + 7);
                    const upcomingNext7DaysSubscriptions = Object.keys(response.data[index]["Subscriptions"] || {})
                        .filter(subscriptionKey => {
                            const subscription = response.data[index]["Subscriptions"][subscriptionKey];
                            const startDate = new Date(subscription["StartDateTimeUTC.ISO8601"]);
                            return startDate >= now && startDate <= sevenDaysFromNow;
                        })
                        .reduce((obj, key) => {
                            obj[key] = response.data[index]["Subscriptions"][key];
                            return obj;
                        }, {});
                    
                    // Filter subscriptions expiring in the next 7 days
                    const nowExpiring = new Date();
                    const sevenDaysFromNowExpiring = new Date();
                    sevenDaysFromNowExpiring.setDate(sevenDaysFromNowExpiring.getDate() + 7);

                    const expiringNext7DaysSubscriptions = Object.keys(response.data[index]["Subscriptions"] || {})
                        .filter(subscriptionKey => {
                            const subscription = response.data[index]["Subscriptions"][subscriptionKey];
                            const endDate = new Date(subscription["EndDateTimeUTC.ISO8601"]);
                            return endDate >= nowExpiring && endDate <= sevenDaysFromNowExpiring;
                        })
                        .reduce((obj, key) => {
                            obj[key] = response.data[index]["Subscriptions"][key];
                            return obj;
                        }, {});
                    
                    // Filter subscriptions expiring in the next 14 days
                    const nowExpiring14Days = new Date();
                    const fourteenDaysFromNowExpiring = new Date();
                    fourteenDaysFromNowExpiring.setDate(fourteenDaysFromNowExpiring.getDate() + 14);

                    const expiringNext14DaysSubscriptions = Object.keys(response.data[index]["Subscriptions"] || {})
                        .filter(subscriptionKey => {
                            const subscription = response.data[index]["Subscriptions"][subscriptionKey];
                            const endDate = new Date(subscription["EndDateTimeUTC.ISO8601"]);
                            return endDate >= nowExpiring14Days && endDate <= fourteenDaysFromNowExpiring;
                        })
                        .reduce((obj, key) => {
                            obj[key] = response.data[index]["Subscriptions"][key];
                            return obj;
                        }, {});
                    
                    this.setState({
                        activeData: recentSubscriptions,
                        activeData1Day: last24HoursSubscriptions,
                        activeData7Day: upcomingNext7DaysSubscriptions,
                        allActiveData: response.data[index]["Subscriptions"],
                        expiringData: expiringNext7DaysSubscriptions,
                        expiringData14Days: expiringNext14DaysSubscriptions,
                        searchData: response.data[index]["UnitsAndSubscriptions"],
                        UnitsBuildingFloorListSusbcribers: response.data[index]["Units-Building-Floor-List-Subscribers"],
                        // venueType: response.data[index]["VenueType"],
                        venueInfo: response.data[index],
                        keypoolID: Object.keys(response.data[index]["Keypools"])[0],
                        servicePlans: response.data[index]["AvailableServicePlans"],
                        propMgmtID: response.data[index]["PropertyManagementGroup"]["PropertyManagementGroupID"],
                        sharedSecret: response.data[index]["PropertyManagementGroup"]["SharedSecret"],
                        // keyPoolList: sortedKeys,
                        venueAdminList: response.data[index]?.Roles?.["VenueAdministrators"],
                        venueLeasingAgentList: response.data[index]?.Roles?.["LeasingAgents"],
                        
                        currencyName: response.data[index]["ShoppingCart"]["Currencies"][0],
                    });
                    sessionStorage.setItem("venueName", response.data[index]["VenueName"]);
                    console.log('🎯 Dashboard getVenueDetails: About to call getAdmins, getKeypools, getEquipment');
                    this.getAdmins();
                    this.getKeypools();
                    this.getEquipment();
                    // Don't set loadingVenueDetails to false here, we'll do it once at the end
                    this.setState({ unitsArrayAll: undefined });
                    let unitsArrayAll = [];
                    let unitsArraySub = [];
                    let unitsArrayGuest = [];
                    let unitsArrayRoaming = [];
                    let building;
                    let floor;
                    var obj = {};
                    for (let i = 0; i < Object.keys(response.data[index]["Units-Building-Floor-List-Subscribers"]).length; i++) {
                        obj[i] = {};
                        let unitID = Object.keys(response.data[index]["Units-Building-Floor-List-Subscribers"])[i];
                        for (let j = 0; j < Object.keys(response.data[index]["Units-Building-Floor-List-Subscribers"][unitID]).length; j++) {
                            obj[i][j] = {};
                            building = Object.keys(response.data[index]["Units-Building-Floor-List-Subscribers"][unitID])[j];
                            for (var k = 0; k < Object.keys(response.data[index]["Units-Building-Floor-List-Subscribers"][unitID][building]).length; k++) {
                                floor = Object.keys(response.data[index]["Units-Building-Floor-List-Subscribers"][unitID][building])[k];
                                obj[i][j][k] = {
                                    UnitID: unitID,
                                    Building: building,
                                    Floor: floor,
                                    Purpose: response.data[index]["Units-Building-Floor-List-Subscribers"][unitID][building][floor]["purpose"],
                                    vlan: response.data[index]["Units-Building-Floor-List-Subscribers"][unitID][building][floor]["vlan"],
                                    address1: response.data[index]["Units-Building-Floor-List-Subscribers"][unitID][building][floor]["AddressLine1"],
                                    address2: response.data[index]["Units-Building-Floor-List-Subscribers"][unitID][building][floor]["AddressLine2"],
                                    city: response.data[index]["Units-Building-Floor-List-Subscribers"][unitID][building][floor]["City"],
                                    state: response.data[index]["Units-Building-Floor-List-Subscribers"][unitID][building][floor]["State"],
                                    country: response.data[index]["Units-Building-Floor-List-Subscribers"][unitID][building][floor]["Country.ISO3166A3"],
                                    postalcode: response.data[index]["Units-Building-Floor-List-Subscribers"][unitID][building][floor]["PostalCode"],
                                    hasActiveSubscription: response.data[index]["Units-Building-Floor-List-Subscribers"][unitID][building][floor]["hasActiveOrFutureSubscription"],
                                    subscriptions: response.data[index]["Units-Building-Floor-List-Subscribers"][unitID][building][floor]["Subscriptions"],
                                    unitID_internal: response.data[index]["Units-Building-Floor-List-Subscribers"][unitID][building][floor]["UnitID_internal"],
                                    PMSSyncDate: response.data[index]["Units-Building-Floor-List-Subscribers"][unitID][building][floor]["PMS"]["SyncDateTimeUTC"],
                                    PMSRealPageUnitID: response.data[index]["Units-Building-Floor-List-Subscribers"][unitID][building][floor]["PMS"]["RealPageUnitID"],
                                    PMSEntrataUnitSpaceID: response.data[index]["Units-Building-Floor-List-Subscribers"][unitID][building][floor]["PMS"]["EntrataUnitSpaceID"],
                                    smsCode: response.data[index]["Units-Building-Floor-List-Subscribers"][unitID][building][floor]["SMSCode"],
                                    shoppingCartPriceAdjustment: response.data[index]["Units-Building-Floor-List-Subscribers"][unitID][building][floor]["ShoppingCartPriceAdjustment"],
                                    allowOverlappingSubscriptionWiredUnit: response.data[index]["Units-Building-Floor-List-Subscribers"][unitID][building][floor]["allowOverlappingSubscriptionWiredUnit"],
                                    primaryUnitID_Internal: response.data[index]["Units-Building-Floor-List-Subscribers"][unitID][building][floor]["PrimaryUnitID_internal"],
                                    selectedServicePlanPrice: response.data[index]["Units-Building-Floor-List-Subscribers"][unitID][building][floor]["ListBillingCyclePrice"],
                                    enableShoppingCart: response.data[index]["Units-Building-Floor-List-Subscribers"][unitID][building][floor]["enableShoppingCart"],
                                    externalVenueUnitID: response.data[index]["Units-Building-Floor-List-Subscribers"][unitID][building][floor]["externalVenueUnitID"],
                                };
                                unitsArraySub.push(obj[i][j][k]);
                            }
                        }
                    }
                    for (let i = 0; i < Object.keys(response.data[index]["Units-Building-Floor-List-GuestNetworks"]).length; i++) {
                        obj[i] = {};
                        let unitID = Object.keys(response.data[index]["Units-Building-Floor-List-GuestNetworks"])[i];
                        for (let j = 0; j < Object.keys(response.data[index]["Units-Building-Floor-List-GuestNetworks"][unitID]).length; j++) {
                            obj[i][j] = {};
                            building = Object.keys(response.data[index]["Units-Building-Floor-List-GuestNetworks"][unitID])[j];
                            for (var k = 0; k < Object.keys(response.data[index]["Units-Building-Floor-List-GuestNetworks"][unitID][building]).length; k++) {
                                floor = Object.keys(response.data[index]["Units-Building-Floor-List-GuestNetworks"][unitID][building])[k];
                                obj[i][j][k] = {
                                    UnitID: unitID,
                                    Building: building,
                                    Floor: floor,
                                    Purpose: response.data[index]["Units-Building-Floor-List-GuestNetworks"][unitID][building][floor]["purpose"],
                                    vlan: response.data[index]["Units-Building-Floor-List-GuestNetworks"][unitID][building][floor]["vlan"],
                                    address1: response.data[index]["Units-Building-Floor-List-GuestNetworks"][unitID][building][floor]["AddressLine1"],
                                    address2: response.data[index]["Units-Building-Floor-List-GuestNetworks"][unitID][building][floor]["AddressLine2"],
                                    city: response.data[index]["Units-Building-Floor-List-GuestNetworks"][unitID][building][floor]["City"],
                                    state: response.data[index]["Units-Building-Floor-List-GuestNetworks"][unitID][building][floor]["State"],
                                    country: response.data[index]["Units-Building-Floor-List-GuestNetworks"][unitID][building][floor]["Country.ISO3166A3"],
                                    postalcode: response.data[index]["Units-Building-Floor-List-GuestNetworks"][unitID][building][floor]["PostalCode"],
                                    hasActiveSubscription: response.data[index]["Units-Building-Floor-List-GuestNetworks"][unitID][building][floor]["hasActiveOrFutureSubscription"],
                                    subscriptions: response.data[index]["Units-Building-Floor-List-GuestNetworks"][unitID][building][floor]["Subscriptions"],
                                    unitID_internal: response.data[index]["Units-Building-Floor-List-GuestNetworks"][unitID][building][floor]["UnitID_internal"],
                                    PMSSyncDate: response.data[index]["Units-Building-Floor-List-GuestNetworks"][unitID][building][floor]["PMS"]["SyncDateTimeUTC"],
                                    smsCode: response.data[index]["Units-Building-Floor-List-GuestNetworks"][unitID][building][floor]["SMSCode"],
                                    shoppingCartPriceAdjustment: response.data[index]["Units-Building-Floor-List-GuestNetworks"][unitID][building][floor]["ShoppingCartPriceAdjustment"],
                                    allowOverlappingSubscriptionWiredUnit: response.data[index]["Units-Building-Floor-List-GuestNetworks"][unitID][building][floor]["allowOverlappingSubscriptionWiredUnit"],
                                    primaryUnitID_Internal: response.data[index]["Units-Building-Floor-List-GuestNetworks"][unitID][building][floor]["PrimaryUnitID_internal"],
                                    selectedServicePlanPrice: response.data[index]["Units-Building-Floor-List-GuestNetworks"][unitID][building][floor]["ListBillingCyclePrice"],
                                    enableShoppingCart: response.data[index]["Units-Building-Floor-List-GuestNetworks"][unitID][building][floor]["enableShoppingCart"],
                                    externalVenueUnitID: response.data[index]["Units-Building-Floor-List-GuestNetworks"][unitID][building][floor]["externalVenueUnitID"],
                                };
                                unitsArrayGuest.push(obj[i][j][k]);
                            }
                        }
                    }
                    
                    for (var i = 0; i < Object.keys(response.data[index]["Units-Building-Floor-List-RoamingNetworks"]).length; i++) {
                        obj[i] = {};
                        let unitID = Object.keys(response.data[index]["Units-Building-Floor-List-RoamingNetworks"])[i];
                        
                        for (let j = 0; j < Object.keys(response.data[index]["Units-Building-Floor-List-RoamingNetworks"][unitID]).length; j++) {
                            obj[i][j] = {};
                            building = Object.keys(response.data[index]["Units-Building-Floor-List-RoamingNetworks"][unitID])[j];
                            for (var k = 0; k < Object.keys(response.data[index]["Units-Building-Floor-List-RoamingNetworks"][unitID][building]).length; k++) {
                                floor = Object.keys(response.data[index]["Units-Building-Floor-List-RoamingNetworks"][unitID][building])[k];
                                obj[i][j][k] = {
                                    UnitID: unitID,
                                    Building: building,
                                    Floor: floor,
                                    Purpose: response.data[index]["Units-Building-Floor-List-RoamingNetworks"][unitID][building][floor]["purpose"],
                                    vlan: response.data[index]["Units-Building-Floor-List-RoamingNetworks"][unitID][building][floor]["vlan"],
                                    address1: response.data[index]["Units-Building-Floor-List-RoamingNetworks"][unitID][building][floor]["AddressLine1"],
                                    address2: response.data[index]["Units-Building-Floor-List-RoamingNetworks"][unitID][building][floor]["AddressLine2"],
                                    city: response.data[index]["Units-Building-Floor-List-RoamingNetworks"][unitID][building][floor]["City"],
                                    state: response.data[index]["Units-Building-Floor-List-RoamingNetworks"][unitID][building][floor]["State"],
                                    country: response.data[index]["Units-Building-Floor-List-RoamingNetworks"][unitID][building][floor]["Country.ISO3166A3"],
                                    postalcode: response.data[index]["Units-Building-Floor-List-RoamingNetworks"][unitID][building][floor]["PostalCode"],
                                    hasActiveSubscription: response.data[index]["Units-Building-Floor-List-RoamingNetworks"][unitID][building][floor]["hasActiveOrFutureSubscription"],
                                    subscriptions: response.data[index]["Units-Building-Floor-List-RoamingNetworks"][unitID][building][floor]["Subscriptions"],
                                    unitID_internal: response.data[index]["Units-Building-Floor-List-RoamingNetworks"][unitID][building][floor]["UnitID_internal"],
                                    PMSSyncDate: response.data[index]["Units-Building-Floor-List-RoamingNetworks"][unitID][building][floor]["PMS"]["SyncDateTimeUTC"],
                                    smsCode: response.data[index]["Units-Building-Floor-List-RoamingNetworks"][unitID][building][floor]["SMSCode"],
                                    shoppingCartPriceAdjustment: response.data[index]["Units-Building-Floor-List-RoamingNetworks"][unitID][building][floor]["ShoppingCartPriceAdjustment"],
                                    allowOverlappingSubscriptionWiredUnit: response.data[index]["Units-Building-Floor-List-RoamingNetworks"][unitID][building][floor]["allowOverlappingSubscriptionWiredUnit"],
                                    primaryUnitID_Internal: response.data[index]["Units-Building-Floor-List-RoamingNetworks"][unitID][building][floor]["PrimaryUnitID_internal"],
                                    selectedServicePlanPrice: response.data[index]["Units-Building-Floor-List-RoamingNetworks"][unitID][building][floor]["ListBillingCyclePrice"],
                                    enableShoppingCart: response.data[index]["Units-Building-Floor-List-RoamingNetworks"][unitID][building][floor]["enableShoppingCart"],
                                    externalVenueUnitID: response.data[index]["Units-Building-Floor-List-RoamingNetworks"][unitID][building][floor]["externalVenueUnitID"],
                                };
                                unitsArrayRoaming.push(obj[i][j][k]);
                            }
                        }
                    }
                    console.log('Dashboard: Finished processing units data, combining into single array');
                    console.log('Roaming Units:', unitsArrayRoaming);
                    unitsArrayAll = unitsArraySub.concat(unitsArrayGuest, unitsArrayRoaming);
                    // Set loading to false immediately when data processing is complete
                    this.setState({
                        unitsArrayAll: [...unitsArrayAll],
                        loadingVenueDetails: false
                    });
                    console.log('Dashboard: Venue details loaded and processed successfully');
                    // key = Object.keys(response.data[index]["Subscriptions"]);
                })
                .catch((error) => {
                    console.error('❌ Dashboard getVenueDetails: API call failed with error:', error);
                    this.setState(
                        {
                            error: true,
                            loadingVenueDetails: false,
                        },
                        () => {
                            console.log("%c loadingVenueDetails set to FALSE (error) ❌", "background: red; color: white; font-size: 14px");
                        }
                    );
                });
        } else {
            console.warn('⚠️ Dashboard getVenueDetails: Index is undefined, skipping API call');
            // If index is undefined, clear loading state immediately
            // console.log("%c Index is undefined, setting loadingVenueDetails to false", "background: orange; color: black; font-size: 14px");
            this.setState(
                {
                    loadingVenueDetails: false,
                },
                () => {
                    // console.log("%c loadingVenueDetails set to FALSE (undefined index) ⚠️", "background: orange; color: black; font-size: 14px");
                }
            );
        }
    };
    getKeypools = async () => {
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            VenueID: sessionStorage.getItem("venueID"),
        };
        await axios
            .post("/networkoperatorconsole/keypools/listKeypools", body, {
                headers: {},
            })
            .then((response) => {
                var sortedKeys = _(response.data["myKeyPoolList"])
                    .map(function (v, k) {
                        // insert the key into the object
                        return _.merge({}, v, { key: k });
                    })
                    .sortBy("DisplayOrder") // sort by name
                    .value();
                this.setState({ 
                    keyPoolList: sortedKeys,

                 });
            })
            .catch((error) => {});
    }
    getEquipment = async () => {
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            VenueID: sessionStorage.getItem("venueID"),
        };
        await axios
            .post("/operatorconsole/venues/listVenueEquipment", body, {
                headers: {},
            })
            .then((response) => {
                this.setState({ venueEquipList: response.data.Equipment });
            })
            .catch((error) => {});
    }
    getUserInfo = () => {
        const body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            EmailAddress: sessionStorage.getItem("userEmail"),
            authorizationToken: sessionStorage.getItem("authorizationToken"),
        };
        return axios
            .post("/networkoperatorconsole/subscribers/listSubscriberKeys", body, {
                headers: {},
            })
            .then((response) => {
                sessionStorage.setItem("firstName", response.data.GivenName);
                sessionStorage.setItem("lastName", response.data.FamilyName);
                sessionStorage.setItem("email", response.data.EmailAddress);
                sessionStorage.setItem("phoneNumber", response.data["PhoneNumber.E164"]);
                sessionStorage.setItem("adminSubscriberToken", response.data["SubscriberToken"]);
                sessionStorage.setItem("subscriberManagedviaSSO", response.data.SubscriberManagedviaSSO);
            })
            .catch((error) => {});
    };
    getPropertyManagementGroups = async () => {
        // console.log('🚨 Dashboard getPropertyManagementGroups called');
        // console.trace('Call stack for getPropertyManagementGroups');
        const data = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
        };
        await axios
            .post("/networkoperatorconsole/venues/listPropertyManagementGroups", data, {
                headers: {},
            })
            .then((response) => {
                this.setState({ propMgmtGroupList: response.data });
            })
            .catch((error) => {});
    };
    getAdmins = () => {
        this.setState({ staffArrayAll: undefined });
        let staffArrayAll = [];
        let staffArrayVA = [];
        let staffArrayLeasing = [];
        for (var i = 0; i < this.state.venueAdminList.length; i++) {
            staffArrayVA[i] = {
                [this.state.venueAdminList[i]]: "Venue Administrator",
            };
        }
        for (var j = 0; j < this.state.venueLeasingAgentList.length; j++) {
            staffArrayLeasing[j] = {
                [this.state.venueLeasingAgentList[j]]: "Leasing Agent",
            };
        }
        staffArrayAll = staffArrayVA.concat(staffArrayLeasing);
        this.setState({ staffArrayAll: [...staffArrayAll] });
    };
    handleResultSelect = (e, { result }) => {
        this.setState({ SubscriberGivenName: result.firstName });
        this.setState({ SubscriberFamilyName: result.lastName });
        this.setState({ UnitID: result.unitID });
        this.setState({ UnitID_internal: result.unitID_internal });
        this.setState({ StartDateTime: result.startDate });
        this.setState({ contactpref_email: result.contactpref_email });
        this.setState({ contactpref_sms: result.contactpref_sms });
        this.setState({ SubscriberPhoneNumber: result.phoneNumber });
        this.setState({ SubscriberLocale: result.locale });
        this.setState({ EndDateTime: result.endDate });
        this.setState({ UnitFloor: result.floor });
        this.setState({ UnitBuilding: result.building });
        this.setState({ SubscriberEmail: result.email });
        this.setState({ redirect: true });
        this.setState({ value: result.title });
        this.setState({ ssid: result.ssid });
        this.setState({ servicePlanID: result.servicePlanID });
        this.setState({ servicePlan: result.servicePlan });
        this.setState({ vlan: result.vlan });
        this.setState({ status: result.status });
        this.setState({
            modalModifyResident: !this.state.modalModifyResident,
        });
        this.setState({ subscriptionDiscount: result.subscriptionDiscount });
        this.setState({ venueDiscount: result.venueDiscount });
        this.setState({ externalSubscriberID: result.externalSubscriberID });
        this.setState({
            primaryUnitID_Internal: result.primaryUnitID_Internal,
        });
        this.setState({
            selectedServicePlanPrice: result.selectedServicePlanPrice,
        });
    };
    toggle = () => {
        this.setState({
            modal: !this.state.modal,
        });
    };
    toggleModifyResident = () => {
        this.setState({
            modalModifyResident: !this.state.modalModifyResident,
        });
    };
    toggleModifyVenue = () => {
        this.setState({
            modalModifyVenue: !this.state.modalModifyVenue,
        });
    };
    refresh = () => {
        this.setState({ refreshed: true });
    };
    handleSearchChange = (e, { value }) => {
        this.setState({ isLoading: true, value });
        let re = "";
        setTimeout(() => {
            this.setState({ results: "" });
            if (this.state.value.length < 1) return this.setState(initialState);
            re = new RegExp(_.escapeRegExp(this.state.value), "i");
            const isMatch = (result) => re.test(result.title + result.description + result.email);
            this.setState({
                filteredResults: _.reduce(
                    source1,
                    (memo2, data, name) => {
                        let results = _.filter(data.results, isMatch);
                        if (results.length || results[0] !== undefined) memo2[name] = { name, results }; // eslint-disable-line no-param-reassign
                        return memo2;
                    },
                    {}
                ),
            });
            this.setState({
                isLoading: false,
                results: this.state.filteredResults,
            });
        }, 300);
    };
    getOperatorInfo = () => {
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
        };
        this.setState({
            allowOverlapping: undefined,
        });
        return axios
            .post("/networkoperatorconsole/equipment/listOperatorDetails", body, {
                headers: {},
            })
            .then(
                (response) => {
                    this.setState({
                        allowOverlapping: response.data.NetworkConfiguration.allowOverlappingSubscriptionWiredUnit,
                    });
                },
                (error) => {
                    console.log("🚀 ~ file: Navigation.js:191 ~ Navigation ~ error", error);
                }
            );
    };
    modifyVenue = (venueName, key) => {
        this.setState({
            modalModifyVenue: !this.state.modalModifyVenue,
        });
        this.setState({
            venueID: key,
        });
        this.handleSelectChangeVenueFromList(venueName, key);
        // this.getVenues(key);
    };
    modifyVenueInfo = (
        address1,
        address2,
        phoneNumber,
        country,
        city,
        region,
        zipcode,
        email,
        countdown,
        durationResident,
        durationGuest,
        durationRoaming,
        contactFirstName,
        contactLastName,
        minVlanRes,
        maxVlanRes,
        minVlanGuest,
        maxVlanGuest,
        minVlanRoaming,
        maxVlanRoaming,
        venueType,
        shoppingCartPriceAdjustment,
        enableShoppingCart,
        sendSubscriptionAddedEmail,
        sendSubscriptionEndEmail,
        allowOverlapping,
        trialCycleAdjustment,
        stripePublishableKey,
        stripeSecretKey,
        stripeWebhookSigningSecret,
        venueName,
        displayFCCLabel,
        typicalLatency,
        displayOptionID,
        externalVenueID,
        selectedPMSProfile,
        PMSEnableUnitSync,
        PMSEnableSubscriberSync,
        PMSRealPageSiteId,
        PMSEntrataPropertyId,
        PMSBlacklistedEmails
    ) => {
        if (address2 === undefined) {
            address2 = "";
        }
        this.setState({ loading: true });
        this.setState({ reloadVenueList: true });
        let updateVenue;
        typicalLatency !== ""
            ? (updateVenue = {
                  VenueID: sessionStorage.getItem("venueID"),
                  VenueName: venueName,
                  AddressLine1: address1,
                  AddressLine2: address2,
                  City: city,
                  State: region,
                  PostalCode: zipcode,
                  "Country.ISO3166A3": country,
                  AccessToken: sessionStorage.getItem("AccessToken"),
                  IdToken: sessionStorage.getItem("IdToken"),
                  WelcomeEmail_countdown_hours: countdown,
                  DefaultSubscriptionDurationHours_GlobalWirelessPlusLocalWiredAccess: durationResident,
                  DefaultSubscriptionDurationHours_LocalWirelessAccess: durationGuest,
                  DefaultSubscriptionDurationHours_GlobalWirelessRoaming:
                    durationRoaming,
                  PrimaryContactGivenName: contactFirstName,
                  PrimaryContactFamilyName: contactLastName,
                  PrimaryContactEmailAddress: email,
                  "PrimaryContactPhoneNumber.E164": phoneNumber,
                  MinimumAutoGeneratedVLAN_GlobalWirelessPlusLocalWiredAccess: minVlanRes,
                  MaximumAutoGeneratedVLAN_GlobalWirelessPlusLocalWiredAccess: maxVlanRes,
                  MinimumAutoGeneratedVLAN_LocalWirelessAccess: minVlanGuest,
                  MaximumAutoGeneratedVLAN_LocalWirelessAccess: maxVlanGuest,
                  MinimumAutoGeneratedVLAN_GlobalWirelessRoaming: minVlanRoaming,
                  MaximumAutoGeneratedVLAN_GlobalWirelessRoaming: maxVlanRoaming,
                  PMS: (() => {
                      const pms = {
                          enableUnitSync: PMSEnableUnitSync,
                          enableSubscriberSync: PMSEnableSubscriberSync
                      };
                      
                      // Always include ProfileID (single space for unlink, actual ID for link)
                      if (selectedPMSProfile) {
                          pms.ProfileID = selectedPMSProfile;
                      }
                      
                      // Check if unlinking (ProfileID is single space)
                      const isUnlinking = selectedPMSProfile === " ";
                      
                      if (isUnlinking) {
                          // When unlinking, send empty venue-specific configuration to clear it
                          pms.RealPage = {
                              SiteId: " "
                          };
                          pms.Entrata = {
                              PropertyID: " "
                          };
                      } else {
                          // When linking, only include venue-specific configuration if present
                          if (PMSRealPageSiteId) {
                              pms.RealPage = {
                                  SiteId: PMSRealPageSiteId
                              };
                          }
                          if (PMSEntrataPropertyId) {
                              pms.Entrata = {
                                  PropertyID: PMSEntrataPropertyId
                              };
                          }
                      }
                      
                      // Add blacklisted subscriber emails
                      if (PMSBlacklistedEmails) {
                          pms.blacklistedSubscriberEmails = PMSBlacklistedEmails;
                      }
                      
                      return pms;
                  })(),
                //   VenueType: venueType,
                  ShoppingCartPriceAdjustment: -Math.abs(shoppingCartPriceAdjustment) * 100,
                  enableShoppingCart: enableShoppingCart,
                  sendSubscriptionAddedEmail: sendSubscriptionAddedEmail,
                  sendSubscriptionEndEmail: sendSubscriptionEndEmail,
                  allowOverlappingSubscriptionWiredUnit: allowOverlapping,
                  TrialCycleAdjustment: trialCycleAdjustment,
                  StripePublishableKey: stripePublishableKey,
                  Stripe_Secret_key: stripeSecretKey,
                  Stripe_Webhook_signingsecret: stripeWebhookSigningSecret,
                  FCCLabel: {
                      displayLabel: displayFCCLabel,
                      TypicalLatency: typicalLatency,
                  },
                  DisplayOptionID: displayOptionID,
                  externalVenueID: externalVenueID,
              })
            : (updateVenue = {
                  VenueID: sessionStorage.getItem("venueID"),
                  VenueName: venueName,
                  AddressLine1: address1,
                  AddressLine2: address2,
                  City: city,
                  State: region,
                  PostalCode: zipcode,
                  "Country.ISO3166A3": country,
                  AccessToken: sessionStorage.getItem("AccessToken"),
                  IdToken: sessionStorage.getItem("IdToken"),
                  WelcomeEmail_countdown_hours: countdown,
                  DefaultSubscriptionDurationHours_GlobalWirelessPlusLocalWiredAccess: durationResident,
                  DefaultSubscriptionDurationHours_LocalWirelessAccess: durationGuest,
                  DefaultSubscriptionDurationHours_GlobalWirelessRoaming:
                    durationRoaming,
                  PrimaryContactGivenName: contactFirstName,
                  PrimaryContactFamilyName: contactLastName,
                  PrimaryContactEmailAddress: email,
                  "PrimaryContactPhoneNumber.E164": phoneNumber,
                  MinimumAutoGeneratedVLAN_GlobalWirelessPlusLocalWiredAccess: minVlanRes,
                  MaximumAutoGeneratedVLAN_GlobalWirelessPlusLocalWiredAccess: maxVlanRes,
                  MinimumAutoGeneratedVLAN_LocalWirelessAccess: minVlanGuest,
                  MaximumAutoGeneratedVLAN_LocalWirelessAccess: maxVlanGuest,
                  MinimumAutoGeneratedVLAN_GlobalWirelessRoaming: minVlanRoaming,
                  MaximumAutoGeneratedVLAN_GlobalWirelessRoaming: maxVlanRoaming,
                  PMS: (() => {
                      const pms = {
                          enableUnitSync: PMSEnableUnitSync,
                          enableSubscriberSync: PMSEnableSubscriberSync
                      };
                      
                      // Always include ProfileID (single space for unlink, actual ID for link)
                      if (selectedPMSProfile) {
                          pms.ProfileID = selectedPMSProfile;
                      }
                      
                      // Check if unlinking (ProfileID is single space)
                      const isUnlinking = selectedPMSProfile === " ";
                      
                      if (isUnlinking) {
                          // When unlinking, send empty venue-specific configuration to clear it
                          pms.RealPage = {
                              SiteId: " "
                          };
                          pms.Entrata = {
                              PropertyID: " "
                          };
                      } else {
                          // When linking, only include venue-specific configuration if present
                          if (PMSRealPageSiteId) {
                              pms.RealPage = {
                                  SiteId: PMSRealPageSiteId
                              };
                          }
                          if (PMSEntrataPropertyId) {
                              pms.Entrata = {
                                  PropertyID: PMSEntrataPropertyId
                              };
                          }
                      }
                      
                      // Add blacklisted subscriber emails
                      if (PMSBlacklistedEmails) {
                          pms.blacklistedSubscriberEmails = PMSBlacklistedEmails;
                      }
                      
                      return pms;
                  })(),
                //   VenueType: venueType,
                  ShoppingCartPriceAdjustment: -Math.abs(shoppingCartPriceAdjustment) * 100,
                  enableShoppingCart: enableShoppingCart,
                  sendSubscriptionAddedEmail: sendSubscriptionAddedEmail,
                  sendSubscriptionEndEmail: sendSubscriptionEndEmail,
                  allowOverlappingSubscriptionWiredUnit: allowOverlapping,
                  TrialCycleAdjustment: trialCycleAdjustment,
                  StripePublishableKey: stripePublishableKey,
                  Stripe_Secret_key: stripeSecretKey,
                  Stripe_Webhook_signingsecret: stripeWebhookSigningSecret,
                  FCCLabel: {
                      displayLabel: displayFCCLabel,
                  },
                  DisplayOptionID: displayOptionID,
                  externalVenueID: externalVenueID,
              });
        Promise.all([
            axios.post("/networkoperatorconsole/venues/configureVenue", updateVenue, {
                headers: {},
            }),
        ])
            .then(async ([res1]) => {
                toast.success("Updated Venue!", {
                    closeButton: false,
                });
                this.setState({ loading: false });
                this.toggleModifyVenue();
                this.setState({ reloadVenueList: false });
                this.updateName(sessionStorage.getItem("venueName"), sessionStorage.getItem("venueID"));
            })
            .catch((error) => {
                toast.error(error.response.data.message, {
                    closeButton: false,
                });
                this.toggleModifyVenue();
                this.setState({ loading: false });
                this.setState({ reloadVenueList: false });
                this.updateName(sessionStorage.getItem("venueName"), sessionStorage.getItem("venueID"));
            });
    };
    handleSelectChangeVenue = (value) => {
        // console.log('🚨 handleSelectChangeVenue called with:', value);
        var venue = document.getElementsByClassName("venueSelectedResidentModal")[0].value;
        this.setState({ selectedID: value[0] });
        this.updateNameForModal(venue, value[0]); // Use modal-specific method for Dashboard dropdown
    };
    handleSelectChangeVenueFromList = (venueName, venueID) => {
        // console.log('🚨 handleSelectChangeVenueFromList called with:', { venueName, venueID });
        sessionStorage.setItem("venueID", venueID);
        sessionStorage.setItem("venueName", venueName);
        this.setState({ 
            selectedID: venueID,
            selectedName: venueName,
            venueID: venueID 
        });
        // Only load venue details for modal opening (no supporting data needed)
        this.getVenueDetails(venueID);
    };
    handleSwitchChange = (nr) => () => {
        this.setState({
            darkmode: !JSON.parse(this.state.darkmode),
        });
        localStorage.setItem("darkMode", !JSON.parse(this.state.darkmode));
        let element = document.getElementsByTagName("body")[0];
        element.setAttribute("data-theme", "darkMode-" + !JSON.parse(this.state.darkmode));
        this.getDisplayOptions();
    };
    render() {
        // console.log("Dashboard render - loadingVenueDetails:", this.state.loadingVenueDetails);
        const { t } = this.props;
        return (
            <>
                {/* Loading modal for venue selection - at top level */}
                <ToastContainer hideProgressBar={true} newestOnTop={true} autoClose={10000} />
                {/* Venue details loading modal - always available regardless of other loading states */}
                {/* {this.state.loadingVenueDetails && (
        <div
            className="overlayVenueLoading"
            id="overlayVenueLoading"
            style={{ 
              display: "block", 
              zIndex: 2000000,
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              pointerEvents: 'auto'
            }}
            onClick={() => console.log("Overlay clicked, loadingVenueDetails:", this.state.loadingVenueDetails)}
        >
            <div className="overlayMessage" style={{ 
                textAlign: 'center', 
                padding: '2rem',
                backgroundColor: 'white',
                borderRadius: '12px',
                maxWidth: '400px',
                margin: '20vh auto 0',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
                border: '2px solid #007bff',
                top: '25%'
            }}>
                <div
                    className="spinner-border mb-3"
                    role="status"
                    style={{ color: 'var(--primary-color, #007bff)', width: '3rem', height: '3rem' }}
                >
                    <span className="sr-only">Loading...</span>
                </div>
                <h4 style={{ color: 'var(--primary-color, #007bff)', marginBottom: '1rem' }}>
                    Loading Venue Details...
                </h4>
                <p style={{ 
                    color: 'var(--primary-text-color, #6c757d)', 
                    fontSize: '0.9rem' 
                }}>
                    Please wait while we fetch the venue information
                </p>
            </div>
        </div>
    )} */}
                {this.state.isInitialLoading || this.state.venueList === undefined || this.state.propMgmtGroupList === undefined ? (
                    <div className="overlay" id="overlay" style={{ display: "block", zIndex: 9999 }}>
                        <div className="overlayMessage" style={{ backgroundColor: 'white', 
       padding: '30px', 
       borderRadius: '12px', 
       textAlign: 'center',
       boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
       maxWidth: '400px',
       margin: '20px',
       border: "3px solid var(--primary-color, #007bff)" }}>
                            <div className="spinner-border spinner-border-lg text-primary mb-3" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                            <h5 className="mb-2" style={{ color: "var(--primary-text-color, #007bff)" }}>Loading Dashboard...</h5>
                            <div style={{ marginBottom: "1rem" }}>
                                <div
                                    style={{
                                        width: "200px",
                                        height: "6px",
                                        backgroundColor: "#e9ecef",
                                        borderRadius: "3px",
                                        margin: "0 auto",
                                        overflow: "hidden",
                                    }}
                                >
                                    <div
                                        style={{
                                            width: `${this.state.loadingProgress}%`,
                                            height: "100%",
                                            backgroundColor: "var(--primary-color, #007bff)",
                                            transition: "width 0.3s ease",
                                            borderRadius: "3px",
                                        }}
                                    />
                                </div>
                                <p
                                    style={{
                                        color: "var(--primary-text-color, #6c757d)",
                                        marginTop: "0.5rem",
                                        fontSize: "0.9rem",
                                    }}
                                >
                                    {this.state.loadingProgress}% Complete
                                </p>
                            </div>
                            {/* <div style={{ textAlign: 'left', maxWidth: '300px', margin: '0 auto' }}>
                                {Object.entries(this.state.loadingStates).map(([key, isLoading]) => (
                                    <div key={key} style={{ 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        marginBottom: '0.5rem',
                                        fontSize: '0.85rem'
                                    }}>
                                        {isLoading ? (
                                            <MDBSpinner size="sm" style={{ color: 'var(--primary-color, #007bff)', marginRight: '0.5rem' }} />
                                        ) : (
                                            <span style={{ 
                                                color: '#28a745', 
                                                marginRight: '0.5rem',
                                                fontSize: '1rem'
                                            }}>✓</span>
                                        )}
                                        <span style={{ 
                                            color: isLoading ? 'var(--primary-text-color, #6c757d)' : '#28a745',
                                            textTransform: 'capitalize'
                                        }}>
                                            {key.replace(/([A-Z])/g, ' $1').trim()}
                                        </span>
                                    </div>
                                ))}
                            </div> */}
                        </div>
                    </div>
                ) : (
                    <>
                        <div id="networkManagement">
                            <MDBModal isOpen={this.state.modalModifyVenue} toggle={this.toggle} size="fluid" className="form modifyVenueModal" centered>
                                <ModifyVenue
                                    toggleModifyVenue={this.toggleModifyVenue}
                                    modifyVenue={this.modifyVenue}
                                    modifyVenueInfo={this.modifyVenueInfo}
                                    venueID={this.state.venueID}
                                    submitDelete={this.submitDelete}
                                    sharedSecret={this.state.sharedSecret}
                                    attributeForm={this.state.attributeForm}
                                    venueInfo={this.state.venueInfo}
                                    loadingVenueDetails={this.state.loadingVenueDetails}
                                    getVenues={this.state.getVenues}
                                    groupForm={this.state.groupForm}
                                    keypoolForm={this.state.keypoolForm}
                                    unitsArrayAll={this.state.unitsArrayAll}
                                    keyPoolList={this.state.keyPoolList}
                                    servicePlans={this.state.servicePlans}
                                    staffArrayAll={this.state.staffArrayAll}
                                    venueEquipList={this.state.venueEquipList}
                                    getVenueDetails={this.getVenueDetails}
                                    updateName={this.updateName}
                                    keypoolID={this.state.keypoolID}
                                    propMgmtID={this.state.propMgmtID}
                                    loading={this.state.loading}
                                    venueRefreshTrigger={this.state.venueRefreshTrigger}
                                    currencyName={this.state.currencyName}
                                    optionTemplateVenues={this.state.optionTemplateVenues}
                                    displayOptionIDGlobal={this.state.displayOptionID}
                                    optionTemplateDisplayOptions={this.state.optionTemplateDisplayOptions}
                                    venueType={this.state.venueType}
                                    UnitsBuildingFloorListSusbcribers={this.props.UnitsBuildingFloorListSusbcribers}
                                    hasUpdated={this.state.hasUpdated}
                                />
                            </MDBModal>
                            <Navigation
                                updateName={this.updateName}
                                updateVenueList={this.updateVenueList}
                                selectedName={this.state.selectedName}
                                selectedID={this.state.selectedID}
                                address1={this.state.address1}
                                address2={this.state.address2}
                                city={this.state.city}
                                state={this.state.state}
                                postalCode={this.state.postalCode}
                                activeData={this.state.activeData}
                                allActiveData={this.state.allActiveData}
                                keypoolID={this.state.keypoolID}
                                expirations={this.state.expiringData}
                                guestData={this.state.guestData}
                                guestDataExpiring={this.state.guestDataExpiring}
                                venueData={this.state.venueData}
                                venueAdmins={this.state.venueAdmins}
                                leasingAgents={this.state.leasingAgents}
                                tickets={this.state.tickets}
                                loading={this.state.loading}
                                venueType={this.state.venueType}
                                buildings={this.state.buildings}
                                updateSupport={this.getSupportDetails}
                                coreEquipmentState={this.state.coreEquipmentState}
                                cpeEquipmentState={this.state.cpeEquipmentState}
                                venueList={this.state.venueList}
                                availablePlans={this.state.venueServicePlans}
                                UnitsBuildingFloorListSusbcribers={this.state.UnitsBuildingFloorListSusbcribers}
                                venueListForTable={this.state.venueListForTable}
                                handleSwitchChange={this.handleSwitchChange}
                                optionTemplateVenues={this.state.optionTemplateVenues}
                                allowOverlapping={this.state.allowOverlapping}
                                getDisplayOptions={this.getDisplayOptions}
                                s3Directory={this.state.s3Directory}
                                logo={this.state.logo}
                                displayOptionID={this.state.displayOptionID}
                                displayOptionIDGlobal={this.state.displayOptionID}
                                optionTemplateDisplayOptions={this.state.optionTemplateDisplayOptions}
                                operatorName={this.state.operatorName}
                                showSupport={this.state.showSupport}
                                showDevices={this.state.showDevices}
                                getVenues={this.getVenues}
                                getVenuesList={this.getVenuesList}
                                unitsArrayAll={this.state.unitsArrayAll}
                                venueID={this.state.selectedID}
                                venueInfo={this.state.venueInfo}
                                loadingVenueDetails={this.state.loadingVenueDetails}
                                hasUpdated={this.state.hasUpdated}
                                keyPoolList={this.state.keyPoolList}
                                servicePlans={this.state.servicePlans}
                                staffArrayAll={this.state.staffArrayAll}
                                venueEquipList={this.state.venueEquipList}
                                getVenueDetails={this.getVenueDetails}
                                currencyName={this.state.currencyName}
                            />
                            <div id="overlayResidentManagement">
                                <div id="overlayMessage" className="overlayMessage">
                                    {this.state.postMessage}
                                </div>
                            </div>
                            <div className="mainDashboard">
                                <MDBContainer fluid>
                                    <MDBRow className="dashboardRow">
                                        <MDBCol sm="12" md="12" lg="5" xl="4" className="summaryCards">
                                            <MDBCard>
                                                <MDBCardBody>
                                                    <SummaryCardVenues
                                                        venueID={this.state.venueID}
                                                        getVenues={this.getVenues}
                                                        handleSelectChangeVenueFromList={this.handleSelectChangeVenueFromList}
                                                        venueList={this.state.venueList}
                                                        propMgmtGroupList={this.state.propMgmtGroupList}
                                                        sharedSecret={this.state.sharedSecret}
                                                        attributeForm={this.state.attributeForm}
                                                        venueInfo={this.state.venueInfo}
                                                        loadingVenueDetails={this.state.loadingVenueDetails}
                                                        groupForm={this.state.groupForm}
                                                        keypoolForm={this.state.keypoolForm}
                                                        unitsArrayAll={this.state.unitsArrayAll}
                                                        keyPoolList={this.state.keyPoolList}
                                                        servicePlans={this.state.servicePlans}
                                                        staffArrayAll={this.state.staffArrayAll}
                                                        venueEquipList={this.state.venueEquipList}
                                                        getVenueDetails={this.getVenueDetails}
                                                        updateName={this.updateName}
                                                        keypoolID={this.state.keypoolID}
                                                        propMgmtID={this.state.propMgmtID}
                                                        venueListForTable={this.state.venueListForTable}
                                                        optionTemplateVenues={this.state.optionTemplateVenues}
                                                        displayOptionIDGlobal={this.state.displayOptionID}
                                                        optionTemplateDisplayOptions={this.state.optionTemplateDisplayOptions}
                                                        currencyName={this.state.currencyName}
                                                    />
                                                </MDBCardBody>
                                            </MDBCard>
                                            <MDBCard>
                                                <MDBCardBody>
                                                    <SummaryCardSubscribers 
                                                        venueList={this.state.venueList} 
                                                        updateName={this.updateName}
                                                        getVenueDetails={this.getVenueDetails}
                                                        venueRefreshTrigger={this.state.venueRefreshTrigger}
                                                        venueInfo={this.state.venueInfo}
                                                        loadingVenueDetails={this.state.loadingVenueDetails}
                                                        groupForm={this.state.groupForm}
                                                        keypoolForm={this.state.keypoolForm}
                                                        unitsArrayAll={this.state.unitsArrayAll}
                                                        keyPoolList={this.state.keyPoolList}
                                                        servicePlans={this.state.servicePlans}
                                                        staffArrayAll={this.state.staffArrayAll}
                                                        venueEquipList={this.state.venueEquipList}
                                                        keypoolID={this.state.keypoolID}
                                                        propMgmtID={this.state.propMgmtID}
                                                        optionTemplateVenues={this.state.optionTemplateVenues}
                                                        displayOptionIDGlobal={this.state.displayOptionID}
                                                        optionTemplateDisplayOptions={this.state.optionTemplateDisplayOptions}
                                                    />
                                                </MDBCardBody>
                                            </MDBCard>
                                        </MDBCol>
                                        <MDBCol>
                                            <QuickLinks
                                                keypoolID={this.state.keypoolID}
                                                venueID={this.state.selectedID}
                                                venueName={this.state.selectedName}
                                                refresh={this.refresh}
                                                recentResidents={this.state.activeData}
                                                updateName={this.updateName}
                                                venueAdmins={this.state.venueAdmins}
                                                leasingAgents={this.state.leasingAgents}
                                                venueType={this.state.venueType}
                                                buildings={this.state.buildings}
                                                availablePlans={this.state.venueServicePlans}
                                                getVenueDetails={this.getVenueDetails}
                                                allowOverlapping={this.state.allowOverlapping}
                                                displayOptionIDGlobal={this.state.displayOptionID}
                                                optionTemplateDisplayOptions={this.state.optionTemplateDisplayOptions}
                                                optionTemplateVenues={this.state.optionTemplateVenues}
                                                keyPoolList={this.state.keyPoolList}
                                                getKeypools={this.getKeypools}
                                            />
                                            <MDBCard>
                                                <MDBCardBody>
                                                    <h2>Venues</h2>
                                                    <div className="expandCollapse">
                                                        <p
                                                            onClick={() =>
                                                                this.setState({
                                                                    active: !this.state.active,
                                                                })
                                                            }
                                                        >
                                                            {this.state.active ? t("recentservice.showless") : t("recentservice.showmore")}
                                                        </p>
                                                    </div>
                                                    {this.state.venueListForTable !== undefined ? (
                                                        this.state.active === false || this.state.active === undefined ? (
                                                            <div className={this.state.active ? "allVenuesExpanded" : "allVenues"}>
                                                                <ViewVenuesTableSmall venueList={this.state.venueListForTable} refreshed={this.props.refreshed} modifyVenue={this.modifyVenue} />
                                                            </div>
                                                        ) : (
                                                            <div 
                                                                className="allVenuesExpanded"
                                                                style={{
                                                                    // maxHeight: 'calc(100vh - 284px)', // Account for header, navigation, card header, margins
                                                                    overflowY: 'auto',
                                                                    overflowX: 'auto',
                                                                    border: '1px solid #dee2e6',
                                                                    borderRadius: '0.375rem',
                                                                    backgroundColor: 'var(--card-color, #ffffff)',
                                                                    boxShadow: '0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)',
                                                                    // minHeight: '400px' // Ensure minimum height for usability
                                                                }}
                                                            >
                                                                <ViewVenuesTable venueList={this.state.venueListForTable} refreshed={this.props.refreshed} modifyVenue={this.modifyVenue} />
                                                            </div>
                                                        )
                                                    ) : (
                                                        <MDBSpinner small />
                                                    )}
                                                </MDBCardBody>
                                            </MDBCard>
                                        </MDBCol>
                                    </MDBRow>
                                </MDBContainer>
                            </div>
                            <div className="footer">
                                <MDBContainer fluid>
                                    <MDBRow>
                                        <MDBCol className="securedByVaultImage">
                                            <LogoFooter darkMode={localStorage.getItem("darkMode")} />
                                        </MDBCol>
                                    </MDBRow>
                                </MDBContainer>
                            </div>
                        </div>
                    </>
                )}
            </>
        );
    }
}
export default withTranslation()(Dashboard);
